/**
 * Extrai mensagens legíveis de falhas HTTP/rede (evita "[object XMLHttpRequest]" na UI).
 * @param {import('axios').AxiosError} error
 * @returns {string[]}
 */
export function extrairMensagensErro(error) {
    if (error.response) {
        const { status, data, statusText } = error.response;
        
        if (data?.errors?.mensagens?.length) {
            return [...data.errors.mensagens];
        }
        if (data?.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
            const mensagens = Object.values(data.errors)
                .flat()
                .filter((mensagem) => typeof mensagem === 'string' && mensagem.trim())
                .map((mensagem) => `- ${mensagem}\n`);
            if (mensagens.length) {
                return mensagens;
            }
        }
        if (typeof data?.message === 'string' && data.message.trim()) {
            return [data.message];
        }
        if (typeof data?.title === 'string' && data.title.trim()) {
            return [data.title];
        }
        if (typeof data === 'string' && data.trim()) {
            return [data];
        }
        if (status === 500) {
            return ['Erro interno no servidor. Tente novamente mais tarde.'];
        }
        if (status === 403) {
            return ['Você não possui permissão para acessar este conteúdo ou executar esta ação.'];
        }
        if (status === 401) {
            return ['Sua sessão expirou. Faça login novamente para continuar.'];
        }
        if (status === 404) {
            return ['Recurso não encontrado.'];
        }
        if (status === 429) {
            return ['Muitas tentativas. Aguarde alguns instantes e tente novamente.'];
        }
        if (status === 502 || status === 503) {
            return ['Serviço temporariamente indisponível. Tente novamente em alguns minutos.'];
        }
        return [statusText || `Erro ${status} na requisição.`];
    }

    if (error.request) {
        return ['Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'];
    }

    return [error.message || 'Erro na requisição.'];
}
